import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { selectHasSummarizationSettingsPermission } from '../../../../../../pages/call/features/permissions';
import {
    selectIsSummarizationAvailable,
    selectIsSummarizationMailForParticipants,
    setIsSummarizationMailForParticipantsAction,
} from '../../../../../../pages/call/features/summarization';
import { Switch } from '../../../../../components';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../features/flags/selectors';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import css from './styles.css';

export const SummarizationMailRecipientSwitcher: FC = () => {
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const isSummarizationMailForParticipants = useSelector(selectIsSummarizationMailForParticipants);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);

    const onChange = useOnPermissionChange(
        setIsSummarizationMailForParticipantsAction,
        'summarization_mail_for_participants'
    );

    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    if (
        !isSummarizationAvailable ||
        !hasSummarizationSettingsPermission ||
        isSummarizationMailForParticipants === null
    ) {
        return null;
    }

    return (
        <Switch
            className={css.switch}
            labelAfter={
                calendarSummarizationFeatureEnabled
                    ? i18n('settings-v2', 'receive-summary-on-mail-v2')
                    : i18n('settings', 'receive-summary-on-mail')
            }
            checked={isSummarizationMailForParticipants}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
